const setFristChildrenName = (data = null) => {
  return {
    type: 'SET_FRISTCHILDRENNAME',
    data
  }
}

export default {
  setFristChildrenName,
}
